/* eslint-disable react/prop-types */
import { Button, Flex, Typography, Upload } from "antd";
import UploadFileRenderer from "./FileUploadRenderer";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function UploadFile({ 
  title,
  fileList = [], 
  disabled,
  beforeUpload,
  onRemove,
  onPreview,
  activeDelete = true
}){
  return (
    <div style={{ marginBottom: 20 }} >
      <Upload
        style={{ width: '100%', display: 'block' }}
        rootClassName="survey-upload"
        disabled={disabled}
        multiple
        beforeUpload={beforeUpload}
        fileList={fileList}
        onRemove={onRemove}
        itemRender={(_,file, filelist, action) => (
          <UploadFileRenderer
            file={file}
            action={action}
            deleteLoading={false}
            onPreview={() => onPreview(file)}
            activeDelete={activeDelete}
          />
        )}
      >
        <Flex justify="space-between" >
          <div style={{ flex: 1 }} >
            <Typography.Text style={{ display: 'block' }} >
              {title || 'Dokumen'}
            </Typography.Text>
            <Typography.Text type="secondary" >
              File jpeg, png, jpg, pdf, Max. file size: 2 MB
            </Typography.Text>
          </div>
          <Button
            icon={<Icon icon="solar:upload-minimalistic-bold-duotone" width="18" height="18" />}
            disabled={disabled}
          >
            Upload
          </Button> 
        </Flex>
      </Upload>
    </div>
  )
}